import React from "react";
import { Link } from "react-router-dom";
import { Gift, Star, Crown } from "lucide-react";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

const TIERS = [
  { icon: Star, name: "Néroli", subtitle: "Dès le 1er achat", perks: ["1 point = 1€ dépensé", "Cadeau d'anniversaire", "Offres exclusives par email"] },
  { icon: Gift, name: "Argan", subtitle: "Dès 150€ cumulés", perks: ["Tous les avantages Néroli", "Échantillons offerts", "Livraison toujours offerte"] },
  { icon: Crown, name: "Atlas", subtitle: "Dès 400€ cumulés", perks: ["Tous les avantages Argan", "Accès aux éditions limitées", "Diagnostic de peau prioritaire"] },
];

export default function Fidelite() {
  useReveal([]);
  return (
    <>
      <PageHero
        tag="Programme fidélité"
        title="Le Cercle <em>Nerolya</em>"
        subtitle="Parce que la fidélité mérite d'être récompensée — cumulez des points et accédez à des privilèges exclusifs."
        image={IMAGES.fidelite}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Programme fidélité" }]} />

      <section className="products-section reveal">
        <div className="feature-grid">
          {TIERS.map((t) => {
            const Icon = t.icon;
            return (
              <div className="feature-card" key={t.name} data-testid={`tier-${t.name}`}>
                <Icon size={30} color="var(--gold)" strokeWidth={1.5} />
                <h3>{t.name}</h3>
                <p className="section-tag" style={{ marginBottom: "1rem" }}>{t.subtitle}</p>
                <ul className="values-list">
                  {t.perks.map((p) => <li key={p}>{p}</li>)}
                </ul>
              </div>
            );
          })}
        </div>
        <div style={{ textAlign: "center", marginTop: "3rem" }}>
          <Link to="/collections/all" className="btn-primary">Commencer à cumuler</Link>
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
